import type {LoadingStates} from '@Utils/loading.util';

export interface PublishingLoadingStates {
  publishingLoadingState: LoadingStates;
  loadingPublishingOption: PublishingOption | null;
}

export interface PublishingOptionHandlers {
  publishToSocialMedia: () => Promise<void>;
  promoteAsEvent: () => Promise<void>;
  publishAsEmailCampaign: () => Promise<void>;
}

export interface PublishingOptionDefinition {
  icon: string;
  text: string;
  hasPremiumCrown: boolean;
  publish: () => Promise<void>;
}

export interface PublishingOptionsProps extends PublishingOptionHandlers {
  chatId: string;
  hashedId: string;
  loadingStates: PublishingLoadingStates;
  removeLastItemBottomMargin?: boolean;
  excludedOptions?: PublishingOption[];
}

export enum PublishingOption {
  PUBLISH_TO_SOCIAL_MEDIA = 'publishToSocialMedia',
  PROMOTE_AS_EVENT = 'promoteAsEvent',
  PUBLISH_AS_EMAIL_CAMPAIGN = 'publishAsEmailCampaign',
}
